import React from "react";

export const ProjectDetail = ({ project, onBack }) => {
  if (!project) return null;

  return (
    <div id="project-detail" className="project-detail-page">
      <div className="project-detail-container">
        <button className="back-button" onClick={onBack} title="Back to Projects">
          ← Back
        </button>

        <div className="project-detail-content">
          <div className="project-detail-image">
            <img src={project.largeImage} alt={project.title} />
          </div>

          <div className="project-detail-info">
            <h1>{project.title}</h1>
            <p className="project-detail-description">
              Detailed view of {project.title} project. Click the back button above to return to the project gallery.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
